import React, { useRef, useEffect } from 'react';
import cx from 'classnames';
import { Route, Switch } from 'react-router-dom';
import styles from './Forum.module.scss';
import LeftSideBar from './LeftSideBar/LeftSideBar';
import Post from './Post/Post';
import AllTopics from './AllTopics/AllTopics';
import Topic from './Topic/Topic';
import RightSideBar from './RightSideBar/RightSideBar';
import Question from './Question/Question';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import imgEunos from '../../assets/img/forum-eunos.jpg';

const baseURl = '/forum';
const Forum = ({ match: { url }, redirectToOnboard, push }) => {
  useEffect(() => {
    if (redirectToOnboard) push('/forum/onboarding/');
  }, [redirectToOnboard, push]);
  const mainRef = useRef();
  useEffect(() => {
    if (window.innerWidth < 990)
      window.scrollTo({ top: mainRef.current.offsetTop, behavior: 'smooth' });
  }, [url]);
  return (
    <div className={cx(styles.mainContainer, 'container')}>
      <div
        className="col-lg-2 col-md-3 col-sm-12 col-xs-12"
        style={{ paddingRight: 10 }}
      >
        <div className={styles.shadow}>
          <LeftSideBar />
        </div>
      </div>
      <div className="col-lg-8 col-md-9 col-sm-12 col-xs-12" ref={mainRef}>
        <div className={styles.cardlist}>
          <Switch>
            <Route
              path={`${baseURl}/questions/:id/:name/`}
              component={Question}
            />
            <Route path={`${baseURl}/questions/:id/`} component={Question} />
            <Route path={`${baseURl}/all/`} component={AllTopics} />
            <Route path={`${baseURl}/:topic/`} component={Topic} />
            <Route path={`${baseURl}/`} component={Post} />
          </Switch>
        </div>
      </div>
      <div
        className="col-lg-2 col-md-9 col-sm-12 col-xs-12"
        style={{ paddingLeft: 10, float: 'right' }}
      >
        <RightSideBar />
      </div>
      <div
        className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
        style={{ textAlign: 'center' }}
      >
        <div>Powered By:</div>
        <img
          src={imgEunos}
          style={{ width: '300px' }}
          alt="PAYM Eunos Youth Network"
        />
      </div>
    </div>
  );
};

export default connect(
  ({ auth: { user }, entities: { users } }) => ({
    redirectToOnboard:
      !!user && !!users && !!users[user] && !users[user].subscribedTopics,
  }),
  { push }
)(Forum);

export function datetimeToText(date) {
  const seconds = Math.abs(
    Math.round((new Date().getTime() - new Date(date).getTime()) / 1000)
  );
  let data = { number: seconds, text: 'sec' };
  if (seconds >= 60) {
    if (seconds >= 60 * 60) {
      if (seconds >= 60 * 60 * 24) {
        data = {
          number: Math.abs(Math.round(seconds / (60 * 60 * 24))),
          text: 'day',
        };
      } else
        data = {
          number: Math.abs(Math.round(seconds / (60 * 60))),
          text: 'hr',
        };
    } else data = { number: Math.abs(Math.round(seconds / 60)), text: 'min' };
  }
  return `${data.number} ${data.text}${data.number > 1 ? 's' : ''}`;
}
